import { render, staticRenderFns } from "./CMCSidebarSelector.vue?vue&type=template&id=34267633&scoped=true&lang=pug&"
import script from "./CMCSidebarSelector.vue?vue&type=script&lang=js&"
export * from "./CMCSidebarSelector.vue?vue&type=script&lang=js&"
import style0 from "./CMCSidebarSelector.vue?vue&type=style&index=0&id=34267633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34267633",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VDialog,VDivider,VIcon,VSpacer,VSwitch})
